import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SplashScreen } from '@nsd/fe';
import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js';
import { differenceInMilliseconds } from 'date-fns';
import { getBaseData } from '../actions/typesActions';

function CollectBaseData({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const { appInternalName } = useSelector((state) => state.application);
  const { user } = useSelector((state) => state.account);
  const appInsights = useAppInsightsContext();
  const startLoadingAppData = useTrackEvent(
    appInsights,
    'DispatchQoreFE::PerformanceTracking::CollectBaseData::startLoading',
    null
  );
  const finishLoadingAppData = useTrackEvent(
    appInsights,
    'DispatchQoreFE::PerformanceTracking::CollectBaseData::finishLoading',
    null
  );

  useEffect(() => {
    (async function initDataCollection() {
      if (user) {
        const startTime = new Date();
        startLoadingAppData();
        dispatch(getBaseData());
        finishLoadingAppData({
          timeElapsedInMS: differenceInMilliseconds(new Date(), startTime)
        });
      }

      setLoading(false);
    }());
  }, [dispatch, user]);

  if (isLoading) {
    return <SplashScreen appName={appInternalName} />;
  }

  return children;
}

CollectBaseData.propTypes = {
  children: PropTypes.any
};

export default CollectBaseData;
